import React from 'react';
import { Table, Empty, Button, Input, Checkbox, Form, Tooltip, DatePicker, Icon } from 'antd';
import { GREATER_THAN_ZERO, FORMAT_2DECIMALS, FORMAT_5DECIMALS } from '../../../../common/types/regularExpresionType';
import moment from 'moment';
import { VALIDAR_STOCK, LOGISTICA_PRODUCTOS_CON_LOTE, SERIE_POR_PRODUCTO } from '../../../../common/types/parametroType'
import auth from '../../../../common/utility/auth';

export default function DetalleProductoServicioModal(props) {
    const validarStock = auth.user().parametros.filter(m => m.abreviatura === VALIDAR_STOCK)[0].valor === "1" ? true : false;
    const mostrarLoteProducto = auth.user().parametros.filter(m => m.abreviatura === LOGISTICA_PRODUCTOS_CON_LOTE)[0].valor === "1" ? true : false;
    const seriePorProducto = auth.user().parametros.filter(m => m.abreviatura === SERIE_POR_PRODUCTO)[0].valor === "1" ? true : false;

    return (
        <div>
            <Table
                className={'table-producto'}
                scroll={{ x: true }}
                size="small"
                style={{ overflowX: 'auto' }}
                pagination={false}
                dataSource={props.dataSource}
                rowKey={record => record.identifier}
                locale={{
                    emptyText: <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description='Pulse el botón "+ Agregar".'
                    />
                }}
                columns={[
                    {
                        key: 'remove-button',
                        align: 'center',
                        width: 40,
                        fixed: 'left',
                        render: (value, row) => (
                            <span>
                                <div className="custom-options">
                                    <Tooltip placement="top" title="Remover">
                                        <Button
                                            type="danger"
                                            icon="delete"
                                            size={"small"}
                                            onClick={() => props.onRemove(row)}
                                        />
                                    </Tooltip>
                                </div>
                            </span>
                        )
                    },
                    {
                        key: 'asignar-serie-button',
                        align: 'center',
                        width: (seriePorProducto) ? 90 : 0,
                        fixed: 'left',
                        render: (value, row) => (
                        
                            <span>
                                <div className="custom-options" hidden={seriePorProducto ? false : true}>
                                    <Tooltip placement="top" title="Buscar Serie">
                                        <Button
                                            type="primary"
                                            icon="bars"
                                            size={"small"}
                                            disabled={row.flagAplicarSerie ? false : true}
                                            onClick={() => props.onAgregarSerie(row, props.onCalculateDetail,props.onSetFieldsValue, props.onGetFieldValue)}
                                        />
                                    </Tooltip>
                                </div>
                            </span>
                        )
                    },
                    {
                        title: 'Código',
                        dataIndex: 'codigo',
                        key: 'codigo',
                        align: 'center',
                        width: 80,
                    },
                    {
                        title: 'Nombre',
                        dataIndex: 'nombre',
                        key: 'nombre',
                        width: 300,
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    <Tooltip placement="top" title={value}>
                                        {
                                            props.onGetFieldDecorator(`arrNombre[${row.identifier}]`, {
                                                initialValue: value
                                            })(
                                                <Input
                                                    placeholder="Nombre"
                                                    autoComplete="off"
                                                    className="text-left"
                                                    readOnly={true}
                                                    onClick={(e) => props.onChangeNameProduct(row)}
                                                />
                                            )
                                        }
                                    </Tooltip>
                                </Form.Item>
                            )
                        }
                    },
                    {
                        title: (seriePorProducto) ? 'Series' : '',
                        dataIndex: 'detalleSeries',
                        key: 'detalleSeries',
                        width: (seriePorProducto) ? 120 : 0,
                        // ellipsis: true,
                        render: (value, row) => {
                            return (
                                <div className={row.flagAplicarSerie ? '' : 'hide'} 
                                        onClick={() => props.onAgregarSerie(row, props.onCalculateDetail, props.onSetFieldsValue, props.onGetFieldValue)}
                                >
                                    {props.onGetFieldDecorator(`arrDetalleSeries[${row.identifier}]`, { initialValue: value })(
                                        <Input
                                            readOnly
                                            title={props.onGetFieldValue(`arrDetalleSeries[${row.identifier}]`)}
                                            style={{ cursor: 'pointer', border: '1px solid #ffffff' }}

                                        />
                                    )}
                                </div>
                            );
                        }
                    },
                    {
                        title: 'Unidad Medida',
                        dataIndex: 'nombreUnidadMedida',
                        key: 'nombreUnidadMedida',
                        // width: 100,
                        ellipsis: true
                    },
                    {
                        title: 'Lote',
                        dataIndex: 'numeroLote',
                        key: 'numeroLote',
                        align: 'center',
                        // width: 150,
                        className: mostrarLoteProducto ? 'show' : 'hide',

                        render: (value, row) => {
                            return (
                                <Form.Item className={mostrarLoteProducto ? 'show' : 'hide'}>
                                    {props.onGetFieldDecorator(`arrLote[${row.identifier}]`, {
                                        initialValue: value
                                        //rules: [{
                                        //    required: true
                                        //}]
                                    })(
                                        <Input
                                            disabled
                                            placeholder="Lote"
                                            autoComplete="off"
                                            className="text-left"
                                            onBlur={(e) => props.onCalculateDetail(row, "arrLote", e.target.value, 0)}
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                    {
                        title: mostrarLoteProducto === false ? '' : 'Fecha Vcto.',
                        dataIndex: 'fechaVencimiento',
                        key: 'fechaVencimiento',
                        align: 'center',
                        className: mostrarLoteProducto ? 'show' : 'hide',
                        // width: 120,
                        render: (value, row) => {
                            return (
                                <Form.Item className={mostrarLoteProducto ? 'show' : 'hide'}>
                                    {props.onGetFieldDecorator(`arrFechaVencimiento[${row.identifier}]`, {
                                        initialValue: value == null ? null : moment(value, 'DD/MM/YYYY'),
                                        rules: [{
                                            required: row.flagVencimiento,
                                            message: "Formato (dd/mm/yyyy)"
                                        }]
                                    })(
                                        <DatePicker
                                            className="first-input"
                                            style={{ border: '1px solid #d9d9d9' }}
                                            placeholder="dd/mm/yyyy"
                                            disabled={true}
                                            prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                            format="DD/MM/YYYY"
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                    {
                        title: 'Afecto IGV',
                        dataIndex: 'flagAfecto',
                        key: 'flagAfecto',
                        align: 'center',
                        // width: 90,
                        className: 'hide',
                        render: (value, row) => {
                            return (
                                <div>
                                    {props.onGetFieldDecorator(`arrFlagAfecto[${row.identifier}]`, {
                                        valuePropName: 'checked',
                                        initialValue: value
                                    })(
                                        <Checkbox
                                            disabled={true}
                                        //onChange={(e) => props.onCalculateDetail(row, "arrFlagAfecto", e.target.checked, 0, index)}
                                        >
                                        </Checkbox>
                                    )}
                                </div>
                            );
                        }
                    },
                    /*       {
                              title: 'Nro. Registro Sanitario',
                              width: 120,
                              dataIndex: 'numeroRegistroSanitario',
                              key: 'numeroRegistroSanitario',
                              align: 'center',
                              className: mostrarVencimiento ? 'show' : 'hide',
                              render: (value, row) => {
                                  return (
                                      <Form.Item>
                                          {props.onGetFieldDecorator(`arrNumeroRegistroSanitario[${row.identifier}]`, {
                                              initialValue: value
                                          })(
                                              <Input
                                                  placeholder="Nro. Registro Sanitario"
                                                  autoComplete="off"
                                                  className="text-left"
                                                  onBlur={(e) => props.onCalculateDetail(row, "arrNumeroRegistroSanitario", e.target.value, 0)}
      
                                              />
                                          )}
                                      </Form.Item>
                                  );
                              }
                          },
                          */
                    {
                        title: 'Fecha Producción',
                        dataIndex: 'fechaProduccion',
                        key: 'fechaProduccion',
                        align: 'center',
                        // width: 100,
                        className: 'hide',

                        render: (value, row) => {
                            return (
                                <Form.Item className={'hide'}>
                                    {props.onGetFieldDecorator(`arrFechaProduccion[${row.identifier}]`, {
                                        initialValue: moment(value, 'DD/MM/YYYY'),
                                        rules: [{
                                            required: true,
                                            message: "Formato (dd/mm/yyyy)"
                                        }]
                                    })(
                                        <DatePicker
                                            className="first-input"
                                            placeholder="dd/mm/yyyy"
                                            prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                            format="DD/MM/YYYY"
                                            onChange={(_, value) =>
                                                props.onCalculateDetail(row, "arrFechaProduccion", moment(value, 'DD/MM/YYYY'))
                                            }
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                    /*        {
                               title: 'Fecha Vencimiento',
                               dataIndex: 'fechaVencimiento',
                               key: 'fechaVencimiento',
                               align: 'center',
                               width: 100,
                               className: 'hide',
       
                               render: (value, row) => {
                                   return (
                                       <Form.Item className={'hide'}>
                                           {props.onGetFieldDecorator(`arrFechaVencimiento[${row.identifier}]`, {
                                               initialValue: moment(value, 'DD/MM/YYYY'),
                                               rules: [{
                                                   required: true,
                                                   message: "Formato (dd/mm/yyyy)"
                                               }]
                                           })(
                                               <DatePicker
                                                   className="first-input"
                                                   placeholder="dd/mm/yyyy"
                                                   prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                                   format="DD/MM/YYYY"
                                                   onChange={(_, value) =>
                                                       props.onCalculateDetail(row, "arrFechaVencimiento", moment(value, 'DD/MM/YYYY'))
       
                                                   }
                                               />
                                           )}
                                       </Form.Item>
                                   );
                               }
                           }, */


                    {
                        title: 'Valor Unitario',
                        dataIndex: 'precioUnitario',
                        key: 'precioUnitario',
                        align: 'center',
                        // width: 90,
                        className: 'hide',

                        render: (value, row) => {
                            return (
                                <Tooltip title={validarStock ? (row.precioPromedio ? `Precio Unitario Mínimo: ${row.precioPromedio.toFixed(2)}` : '') : ''}>
                                    <Form.Item>
                                        {props.onGetFieldDecorator(`arrPrecioUnitario[${row.identifier}]`, {
                                            initialValue: parseFloat(value).toFixed(5),
                                            rules: [{
                                                required: true,
                                                //pattern: new RegExp(GREATER_THAN_ZERO),
                                                message: "Formato (0.00)"
                                            }]
                                        })(
                                            <Input
                                                disabled={true}
                                                placeholder="P.  Unitario"
                                                autoComplete="off"
                                                className="text-right"
                                                onBlur={(e) => props.onCalculateDetail(row, "arrPrecioUnitario", e.target.value, 5)}
                                            />
                                        )}
                                    </Form.Item>
                                </Tooltip>
                            );
                        }
                    },
                    // {
                    //     title: 'Cantidad',
                    //     dataIndex: 'cantidad',
                    //     key: 'cantidad',
                    //     width: 100,
                    //     ellipsis: true,
                    //     render: (value, row) => {
                    //         return (
                    //             <Tooltip title={validarStock ? (row.stock ? `Stock Disponible: ${row.stock.toFixed(2)}` : '') : ''}>
                    //                 <Form.Item style={{ width: '200px' }}>
                    //                     {props.onGetFieldDecorator(`arrCantidad[${row.identifier}]`, {
                    //                         initialValue: parseFloat(value).toFixed(2),
                    //                         rules: [{
                    //                             required: true,
                    //                             pattern: new RegExp(FORMAT_2DECIMALS),
                    //                             message: "Formato (0.00)"
                    //                         }]
                    //                     })(
                    //                         <Input
                    //                             placeholder="Cantidad"
                    //                             autoComplete="off"
                    //                             className="text-right"
                    //                             // max="2"
                    //                             onBlur={(e) => props.onCalculateDetail(row, "arrCantidad", e.target.value, 2)}
                    //                         />
                    //                     )}
                    //                 </Form.Item>
                    //             </Tooltip>
                    //         );
                    //     }
                    // },
                    {
                        title: 'Cantidad',
                        dataIndex: 'cantidad',
                        key: 'cantidad',
                        // ellipsis: true,
                        // width: 100,
                        render: (value, row) => {
                            return (
                                <Tooltip title={`Stock Disponible: ${row.stock.toFixed(2)}`}>
                                    <Form.Item>
                                        {props.onGetFieldDecorator(`arrCantidad[${row.identifier}]`, {
                                            initialValue: parseFloat(value).toFixed(2),
                                            rules: [{
                                                required: true,
                                                pattern: new RegExp(FORMAT_2DECIMALS),
                                                message: "Formato (0.00)"
                                            }]
                                        })(
                                            <Input
                                                disabled={row.flagAplicarSerie ? true : false}
                                                placeholder="Cantidad"
                                                autoComplete="off"
                                                className="text-right"
                                                onBlur={(e) => props.onCalculateDetail(row, row.idProducto, "arrCantidad", e.target.value, 3)}
                                            />
                                        )}
                                    </Form.Item>
                                </Tooltip>
                            );
                        }
                    },

                ]}
            />
        </div>
    );
}